import React, { Component } from 'react';
import debounce from 'lodash.debounce';
import PropTypes from 'prop-types';
import Quill from 'quill';

import './RichTextInput.css'

class RichTextInput extends Component {

  static propTypes = {
    addField: PropTypes.bool.isRequired,
    addLabel: PropTypes.bool.isRequired,
    input: PropTypes.object,
    label: PropTypes.string,
    options: PropTypes.object,
    source: PropTypes.string,
    toolbar: PropTypes.object,
  };

  static defaultProps = {
    addField: true,
    addLabel: true,
    options: {},
    record: {},
    toolbar: {
      container: [
        [{ 'header': [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'link'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        ['clean'],
      ],
      handlers: {}
    },
  };

  componentDidMount() {
    const {
      input: {
        value,
      },
      toolbar,
    } = this.props;

    this.quill = new Quill(this.divRef, {
      modules: { toolbar },
      theme: 'snow',
    });

    this.quill.pasteHTML(value);

    this.editor = this.divRef.querySelector('.ql-editor');
    this.quill.on('text-change', debounce(this.onTextChange, 500));
  }

  componentWillUnmount() {
    this.quill.off('text-change', this.onTextChange);
    this.quill = null;
  }

  onTextChange = () => {
    this.props.input.onChange(this.editor.innerHTML);
  };

  updateDivRef = ref => {
    this.divRef = ref;
  };

  render() {
    return <div className='aor-rich-text-input'>
      <div ref={this.updateDivRef}/>
    </div>
  }
}

export default RichTextInput;



// WEBPACK FOOTER //
// ./src/components/input/RichTextInput.js